export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '性别',
      prop: '__gender__'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '原级别',
      prop: 'beforeLevel'
    },
    {
      label: '升级后级别',
      prop: 'afterLevel'
    },
    {
      label: '调整方式',
      prop: '__sourceType__'
    },
    {
      label: '操作人员',
      prop: 'updateUserName'
    },
    {
      label: '操作时间',
      prop: 'createTime'
    }
  ]
}
